module.exports = __webpack_public_path__ + "img/loading.1436740c.svg";